"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyAddress = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const address_entity_1 = require("./address.entity");
const company_entity_1 = require("./company.entity");
let CompanyAddress = class CompanyAddress {
    constructor(company, address, isPrimary) {
        this.company = company;
        this.address = address;
        this.isPrimary = isPrimary;
    }
};
exports.CompanyAddress = CompanyAddress;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], CompanyAddress.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "is_primary", default: false }),
    tslib_1.__metadata("design:type", Boolean)
], CompanyAddress.prototype, "isPrimary", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], CompanyAddress.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "address_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], CompanyAddress.prototype, "addressId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => company_entity_1.Company, (company) => company.companyAddresses),
    (0, typeorm_1.JoinColumn)({ name: "company_id" }),
    tslib_1.__metadata("design:type", Object)
], CompanyAddress.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => address_entity_1.Address, (address) => address.companyAddresses, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "address_id" }),
    tslib_1.__metadata("design:type", Object)
], CompanyAddress.prototype, "address", void 0);
exports.CompanyAddress = CompanyAddress = tslib_1.__decorate([
    (0, typeorm_1.Entity)("company_address"),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Boolean])
], CompanyAddress);
